module.exports = __webpack_public_path__ + "img/梅竹_圈-素材.c70fe45c.svg";